import { useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const CODES = {
  js: `<span class="tc">// Create a delivery — one API call</span>
<span class="tw">const</span> res = <span class="tw">await</span> fetch(<span class="ts">'${API_BASE}/orders'</span>, {
  method: <span class="ts">'POST'</span>,
  headers: {
    <span class="ts">'Content-Type'</span>: <span class="ts">'application/json'</span>,
    <span class="ts">'X-API-Key'</span>: <span class="ts">'qk_live_your_key_here'</span>
  },
  body: JSON.stringify({
    pickup_address:  <span class="ts">'Shop 12, Accra Mall'</span>,
    dropoff_address: <span class="ts">'East Legon, Accra'</span>,
    pickup_lat:  <span class="tn">5.6148</span>, pickup_lng:  <span class="tn">-0.2059</span>,
    dropoff_lat: <span class="tn">5.6302</span>, dropoff_lng: <span class="tn">-0.1734</span>,
    service_type:   <span class="ts">'parcel'</span>,
    payment_method: <span class="ts">'cash'</span>,
    webhook_url: <span class="ts">'https://yourbiz.com/webhook'</span>
  })
});
<span class="tw">const</span> { order_id, price, status } = <span class="tw">await</span> res.json();
<span class="tc">// → { order_id: 921, price: 12.50, status: "pending" }</span>`,

  python: `<span class="tw">import</span> requests

res = requests.post(
    <span class="ts">"${API_BASE}/orders"</span>,
    headers={<span class="ts">"X-API-Key"</span>: <span class="ts">"qk_live_your_key_here"</span>},
    json={
        <span class="ts">"pickup_address"</span>:  <span class="ts">"Shop 12, Accra Mall"</span>,
        <span class="ts">"dropoff_address"</span>: <span class="ts">"East Legon, Accra"</span>,
        <span class="ts">"pickup_lat"</span>:  <span class="tn">5.6148</span>, <span class="ts">"pickup_lng"</span>:  <span class="tn">-0.2059</span>,
        <span class="ts">"dropoff_lat"</span>: <span class="tn">5.6302</span>, <span class="ts">"dropoff_lng"</span>: <span class="tn">-0.1734</span>,
        <span class="ts">"service_type"</span>:   <span class="ts">"parcel"</span>,
        <span class="ts">"payment_method"</span>: <span class="ts">"cash"</span>,
    }
).json()

print(f"Order #{res['order_id']} — GHS {res['price']}")`,

  curl: `curl -X POST ${API_BASE}/orders \\
  -H <span class="ts">"Content-Type: application/json"</span> \\
  -H <span class="ts">"X-API-Key: qk_live_your_key_here"</span> \\
  -d <span class="ts">'{
    "pickup_address":  "Shop 12, Accra Mall",
    "dropoff_address": "East Legon, Accra",
    "pickup_lat": 5.6148,  "pickup_lng": -0.2059,
    "dropoff_lat": 5.6302, "dropoff_lng": -0.1734,
    "service_type": "parcel",
    "payment_method": "cash"
  }'</span>

<span class="tc"># Response</span>
{
  <span class="tk">"order_id"</span>:     <span class="tn">921</span>,
  <span class="tk">"status"</span>:      <span class="ts">"pending"</span>,
  <span class="tk">"price"</span>:       <span class="tn">12.50</span>,
  <span class="tk">"distance_km"</span>: <span class="tn">5.0</span>
}`,
};

const ENDPOINTS = [
  { m:"POST", mc:"rgba(34,197,94,0.1)",   mc2:"#4ade80", path:"/v1/orders",               desc:"Create delivery" },
  { m:"GET",  mc:"rgba(59,130,246,0.1)",   mc2:"#60a5fa", path:"/v1/orders/:id",           desc:"Order + status" },
  { m:"GET",  mc:"rgba(59,130,246,0.1)",   mc2:"#60a5fa", path:"/v1/orders/:id/tracking",  desc:"Live GPS" },
  { m:"POST", mc:"rgba(168,85,247,0.12)",  mc2:"#c084fc", path:"/v1/auth/register",         desc:"Register & get token" },
];

export default function CodeWindow() {
  const [tab, setTab] = useState("js");

  return (
    <div style={{ background:"#0c0c13", border:"1px solid var(--border)", borderRadius:"var(--radius)", overflow:"hidden", boxShadow:"var(--glow), 0 40px 80px rgba(0,0,0,0.45)" }}>
      {/* Title bar */}
      <div style={{ display:"flex", alignItems:"center", gap:7, padding:"12px 16px", background:"#10101a", borderBottom:"1px solid var(--border)" }}>
        {["#ff5f56","#ffbd2e","#27c93f"].map(c => <div key={c} style={{ width:11, height:11, borderRadius:"50%", background:c }}/>)}
        <span style={{ marginLeft:"auto", fontFamily:"var(--font-mono)", fontSize:11, color:"var(--text3)" }}>kwikkie-api · v1</span>
      </div>

      {/* Tabs */}
      <div style={{ display:"flex", borderBottom:"1px solid var(--border)" }}>
        {["js","python","curl"].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{
            padding:"10px 18px", fontFamily:"var(--font-mono)", fontSize:12,
            color: tab===t ? "var(--accent)" : "var(--text3)",
            background:"none", border:"none", borderBottom: tab===t ? "2px solid var(--accent)" : "2px solid transparent",
            cursor:"pointer", transition:"all 0.15s",
          }}>
            {t === "js" ? "JavaScript" : t === "python" ? "Python" : "cURL"}
          </button>
        ))}
      </div>

      {/* Code body */}
      <div style={{ padding:"22px", overflowX:"auto", maxHeight:320 }}>
        <pre style={{ fontFamily:"var(--font-mono)", fontSize:12.5, lineHeight:1.75, color:"#c9d1d9", whiteSpace:"pre" }}>
          <style>{`.tc{color:#6e7681}.tk{color:#79c0ff}.ts{color:#a5d6ff}.tn{color:#f2cc60}.tw{color:#ff7b72}.tf{color:#d2a8ff}`}</style>
          <span dangerouslySetInnerHTML={{ __html: CODES[tab] }}/>
        </pre>
      </div>

      {/* Endpoint reference */}
      <div style={{ borderTop:"1px solid var(--border)", background:"#0c0c13" }}>
        {ENDPOINTS.map((ep, i) => (
          <div key={ep.path} style={{ display:"flex", gap:10, alignItems:"center", padding:"9px 16px", borderBottom: i < ENDPOINTS.length-1 ? "1px solid var(--border)" : "none" }}>
            <span style={{ background:ep.mc, color:ep.mc2, borderRadius:4, padding:"2px 7px", fontFamily:"var(--font-mono)", fontSize:10, fontWeight:700, flexShrink:0 }}>{ep.m}</span>
            <span style={{ fontFamily:"var(--font-mono)", color:"var(--text2)", fontSize:12, flex:1 }}>{ep.path}</span>
            <span style={{ fontSize:12, color:"var(--text3)" }}>{ep.desc}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
